import React from "react"
import clsx from "clsx"
import { useTranslation } from "react-i18next"

import classes from "./KitchenTableLevels.module.scss"

const KitchenTableLevels = props => {
  const {
    tables,
    selectedFloor,
    setSelectedFloor
  } = props

  const [t, i18n] = useTranslation()

  const handleClick = (level) => {
    setSelectedFloor(level)
  }

  const getTableLevels = () => {
    const result = []

    tables.forEach(table => {
      !result.includes(table.level) &&
        result.push(table.level)
    })

    return result.reverse()
  }

  const levels = getTableLevels()

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div
      className={clsx(
        classes["container"],
        isLtr && classes["container-ltr"]
      )}
    >
      <div
        className={clsx(
          classes["bold"],
          isLtr && classes["bold-ltr"]
        )}
      >
        {t("طبقات")}:
      </div>
      {levels.map(level =>
        <button
          key={level}
          onClick={() => handleClick(level)}
          className={clsx(
            classes["card"],
            isLtr && classes["card-ltr"],
            level === selectedFloor && classes["active"]
          )}
        >
          {level}
        </button>
      )}
    </div>
  )
}

export default KitchenTableLevels